export default "__VITE_ASSET__C38OGPQW__"